export const createPreviewProps = (metaCatalogId, data) => {
    if (!metaCatalogId || !data)
        return;
    const catalog = data.catalogs.find((catalog) => catalog.id === metaCatalogId);
    if (!catalog)
        return;
    return {
        catalogTitle: catalog.name,
        catalogDescription: 'Facebook Product Catalog',
        catalogFooter: `ID: ${catalog.id}`,
    };
};
